const BASE62_CHARS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function toBase62(input: string): string {
  let num = 0;

  for (let index = 0; index < input.length; index++) {
    num = (num * 31 + input.charCodeAt(index)) >>> 0;
  }

  if (num === 0) {
    return BASE62_CHARS[0];
  }

  let result = "";

  while (num > 0) {
    result = BASE62_CHARS[num % 62] + result;
    num = Math.floor(num / 62);
  }

  return result;
}
